import { css } from 'emotion';

import { colors } from '../styles';

const banner = css`
  background-color: #fffaf2;
  > svg {
    color: ${colors.warning.default};
    margin-right: 10px;
  }
`;

const button = css`
  margin-left: auto;
  > button {
    margin-left: 30px;
  }
`;

export default { banner, button };
